// extracted by mini-css-extract-plugin
export default {"main":"Task_main__fUuAF","CoverDiv":"Task_CoverDiv__6ZmZN","main2":"Task_main2__izR8Q","Content":"Task_Content__RJ3Py","TaskTitle":"Task_TaskTitle__VkCkE"};